var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 779.47 805.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1c2454;}.cls-2{fill:#90c0f4;}.cls-3{fill:#084e9b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M636.44,816.3V994.15H560.85a52.17,52.17,0,0,0-52.17,52.18v62.81H343.6A52.17,52.17,0,0,1,291.42,1057V816.3a52.17,52.17,0,0,1,52.18-52.17H584.26A52.17,52.17,0,0,1,636.44,816.3Z",
    transform: "translate(-291.42 -764.13)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1070.9,816.3V1057a52.17,52.17,0,0,1-52.18,52.18h-165v-62.81a52.2,52.2,0,0,0-52.18-52.18H725.88V816.3a52.17,52.17,0,0,1,52.18-52.17h240.66A52.17,52.17,0,0,1,1070.9,816.3Z",
    transform: "translate(-291.42 -764.13)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M636.44,1339.17V1517a52.17,52.17,0,0,1-52.18,52.17H343.6A52.17,52.17,0,0,1,291.42,1517V1276.31a52.17,52.17,0,0,1,52.18-52.18H508.68V1287a52.2,52.2,0,0,0,52.17,52.18Z",
    transform: "translate(-291.42 -764.13)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1070.9,1276.31V1517a52.17,52.17,0,0,1-52.18,52.17H778.06A52.17,52.17,0,0,1,725.88,1517v-177.8h75.63A52.24,52.24,0,0,0,853.69,1287v-62.86h165A52.17,52.17,0,0,1,1070.9,1276.31Z",
    transform: "translate(-291.42 -764.13)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M853.69,1109.14v115H778.06a52.17,52.17,0,0,0-52.18,52.18v62.86H636.44v-62.86a52.17,52.17,0,0,0-52.18-52.18H508.68v-115h75.58A52.17,52.17,0,0,0,636.44,1057V994.15h89.44V1057a52.17,52.17,0,0,0,52.18,52.18Z",
    transform: "translate(-291.42 -764.13)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M636.44,994.15V1057a52.17,52.17,0,0,1-52.18,52.18H508.68v-62.81a52.17,52.17,0,0,1,52.17-52.18Z",
    transform: "translate(-291.42 -764.13)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M636.44,1276.31v62.86H560.85A52.2,52.2,0,0,1,508.68,1287v-62.86h75.58A52.17,52.17,0,0,1,636.44,1276.31Z",
    transform: "translate(-291.42 -764.13)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M853.69,1046.33v62.81H778.06A52.17,52.17,0,0,1,725.88,1057V994.15h75.63A52.2,52.2,0,0,1,853.69,1046.33Z",
    transform: "translate(-291.42 -764.13)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M853.69,1224.13V1287a52.24,52.24,0,0,1-52.18,52.18H725.88v-62.86a52.17,52.17,0,0,1,52.18-52.18Z",
    transform: "translate(-291.42 -764.13)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3bb27ef1e6104f6f0671411271ec49e4.svg";
export { ForwardRef as ReactComponent };